import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private lastSnapshot?: RouterStateSnapshot;

  constructor(
    private readonly title: Title,
    private readonly transloco: TranslocoService,
  ) {
    super();

    // Le router résout le titre à la fin de la navigation, parfois avant que
    // le fichier de langue ne soit chargé : on réapplique alors le titre dès
    // qu'une traduction (re)charge. On ne le fait que pour les routes ayant
    // une clé de titre, afin de ne jamais écraser les titres dynamiques posés
    // par les composants (vendor / room / booking).
    this.transloco.events$.subscribe((event) => {
      if (
        event.type === 'translationLoadSuccess' &&
        this.lastSnapshot &&
        this.buildTitle(this.lastSnapshot)
      ) {
        this.apply(this.lastSnapshot);
      }
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastSnapshot = snapshot;
    this.apply(snapshot);
  }

  /**
   * Construit le titre de l'onglet à partir de la clé de traduction définie
   * sur la route (`title`), dans la langue active, suivie du nom du produit.
   */
  private apply(snapshot: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(snapshot);
    const appName = this.transloco.translate('page-title.suffix');

    if (titleKey) {
      const pageTitle = this.transloco.translate(titleKey);
      this.title.setTitle(`${pageTitle} - ${appName}`);
    } else {
      this.title.setTitle(appName);
    }
  }
}
